export type ParsedCategory = { slug: string; label: string };

const ALLOWED_CATEGORIES: { slug: string; label: string; aliases?: string[] }[] = [
  { slug: 'kids', label: 'Kids', aliases: ['children', 'child', 'kid'] },
  { slug: 'teens', label: 'Teens', aliases: ['teen', 'teenager', 'teenagers'] },
  { slug: 'culture', label: 'Culture' },
  { slug: 'sports', label: 'Sports', aliases: ['sport'] },
  { slug: 'mystery', label: 'Mystery' },
  { slug: 'science-and-technology', label: 'Science & Technology', aliases: ['science & technology', 'science and technology', 'science-technology'] },
  { slug: 'classics', label: 'Classics', aliases: ['classic'] },
  { slug: 'business', label: 'Business' },
  { slug: 'biography', label: 'Biography', aliases: ['biographies'] },
  { slug: 'fiction', label: 'Fiction', aliases: ['novel', 'novels'] },
];

const normalizeToken = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/^products\.categories\./, '')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const _toTitleCase = (value: string): string =>
  value
    .split('-')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ');

export const parseCategoryString = (raw: string | null | undefined): ParsedCategory[] => {
  if (!raw || typeof raw !== 'string') return [];

  const seen = new Set<string>();
  const tokens = raw.split(',').map((entry) => entry.trim()).filter(Boolean);
  const resolved: ParsedCategory[] = [];

  tokens.forEach((token) => {
    const normalized = normalizeToken(token);
    if (!normalized) return;

    const match = ALLOWED_CATEGORIES.find(
      (category) => category.slug === normalized || category.aliases?.includes(normalized),
    );
    if (!match) return;

    if (seen.has(match.slug)) return;
    seen.add(match.slug);

    resolved.push({
      slug: match.slug,
      label: match.label,
    });
  });

  return resolved;
};

export const allowedCategories = ALLOWED_CATEGORIES;
